import React from 'react'

import {Route, Redirect} from 'react-router'
import {connect} from 'react-redux'

const PrivateRouteComponent = (props) => {
  const Component = props.drawComponent

  return (
      <Route {...props} render={(props) => (
      props.logged_in || localStorage.getItem("login_token") ? (
          <Component {...props} />
          ) : (
          <Redirect to={{
              pathname: '/login',
              state: { from: props.location }
          }} /> )
      )} />
  )
}

const mapStateToProps = (state, ownProps) => {
    return {
        logged_in: state.user.loggedIn
    }
}

const PrivateRoute = connect(mapStateToProps, null)(PrivateRouteComponent)
export default PrivateRoute



// WEBPACK FOOTER //
// ./src/js/helpers/PrivateRoute.js